$( document ).ready(function() {

//video listener
if($('#vsl-video').length > 0 ){
    videojs('vsl-video').ready(function () {
        this.on('timeupdate', function () {
            if(this.currentTime() >= (60*2)){
             $('.vsl .cta').addClass('show');
            }
        //   console.log(this.currentTime());
        })
      });
}

//"POLYPHENOLS-Health Benefits" accordion
    function adjustCollapseView(){
        let desktopView = $(document).width();
        if(desktopView >= "768"){
            $('#accordionHealth .title').attr('data-toggle','');
            $('#blendsAccordion .intro').attr('data-toggle','');
            // $('#accordionHealtFAQ .question').attr('data-toggle','');

            $('#blendsAccordion .hidden').removeClass('collapse');
            $('#blendsAccordion .intro').removeClass('collapsed');
              // $('#accordionHealtFAQ .answer').addClass('collapse');
            // $('#accordionHealtFAQ .answer').removeClass('collapse');
        }else{
            $('#accordionHealth .title').attr('data-toggle','collapse');
            $('#blendsAccordion .intro').attr('data-toggle','collapse');    
            // $('#accordionHealtFAQ .question').attr('data-toggle','collapse');    

            $('#blendsAccordion .intro').addClass('collapsed ellipsis');
            $('#blendsAccordion .hidden').addClass('collapse');
            // $('#accordionHealtFAQ .answer').addClass('collapse');

        }
    }
    
    $(function(){
        adjustCollapseView();
        $(window).on("resize", function(){
            adjustCollapseView();
        });
    });

    $('#blendsAccordion').on('hidden.bs.collapse', function () {
        $('.blends .intro.collapsed').addClass('ellipsis')
      })

//Take to shooping cart
    $('div.cta, .ribbon').on('click', function (event) {
        $('html, body').animate({
            scrollTop: $(".cart").offset().top
        }, 1000);

    });


//Shopping Cart    
    function activeProduct() {
        let thisProduct = $(this);
        let subscribe = $('.purchaseTypeWrap .purchaseType input[type=checkbox]:checked').val();

        let amount, link;

        if(subscribe === 'subscribe'){
            amount =  'data-price-subscribe';
            link = 'data-link-subscribe';
        }else {
            amount =  'data-price' ;
            link = 'data-link';
        }

        $('.cart .products li').removeClass('active');
        thisProduct.addClass('active');

        $('.summary .shipping .shipAmount').html( thisProduct.attr('data-shipping')+ ' Shipping');
        $('.summary .amount ').html('$' +thisProduct.attr(amount));
        $('.summary .regularPrice span').html( '$' +thisProduct.attr('data-regular'));
        $('.summary .saving span').html('$' + (thisProduct.attr('data-regular') - thisProduct.attr(amount)).toFixed(2));
        
        let param = $('.cart .cta').attr('data-param');
        $('.cart .cta').attr('href', thisProduct.attr(link) + param);

        let imgSrc;
        
        if ($(window).width() < 768) {
            imgSrc = thisProduct.attr('data-img-mobile')
        }else{
            imgSrc = thisProduct.attr('data-img')
        }
        
        $('.productChoosen img').attr('src', imgSrc);
     };

     $('.cart .products li').on('click', activeProduct);

     // when choosing 'One Time Payment' or 'subscribe'
     $('.purchaseTypeWrap .purchaseType input[type=checkbox]').on('click', function(){
        $('.cart .products li.active').trigger( "click" )
      });


    //on-load page make product default
    $('.cart .products li:nth-child(2)').trigger("click")
    
    //- Set current Year to footer Copyright
    let thisDate = new Date();
    $('#year').html(thisDate.getFullYear());
});
